/**
 * Mutations related only to manipulating universal state shared by each activity. Use
 * namespaced module (ex. typing) for mutations related to specific use cases.
 */
import getInitialActivityState from './initialState';
import getInitialTypingState from './typing/initialState';
const getStepIndex = (currentStepIndex, options) => {
    const { isFirstStep, step } = options;
    if (Number.isInteger(step))
        return step;
    if (isFirstStep)
        return 0;
    return currentStepIndex + 1;
};
export default {
    setActivityData: (state, activityData) => Object.assign(state, { data: activityData, dataLoaded: true }),
    completeActivitySetup: state => Object.assign(state, { readyToStart: true }),
    createRounds: (state, { rounds, instructions }) => Object.assign(state, { rounds, instructions }),
    incrementRound: state => Object.assign(state.progress, {
        roundIndex: state.progress.roundIndex + 1
    }),
    keepInstructionsOnScreen: (state, keepInstructions) => Object.assign(state, { keepInstructions }),
    overwriteRoundSteps: (state, { roundId, steps, stepIndex }) => {
        const round = state.rounds.filter(stateRound => stateRound.id === roundId);
        round.steps = steps;
        Object.assign(state.progress, { stepIndex: stepIndex || 0 });
    },
    jumpToRound: (state, roundIndex) => Object.assign(state.progress, { roundIndex }),
    incrementStep(state, options = {}) {
        const { stepIndex } = state.progress;
        Object.assign(state.progress, {
            stepIndex: getStepIndex(stepIndex, options)
        });
    },
    completeStep(state, step) {
        const stepIndex = step || state.progress.stepIndex;
        state.progress.completedSteps.push(stepIndex);
    },
    resetCompletedSteps: state => Object.assign(state.progress, { completedSteps: [] }),
    setIntroViewed: state => Object.assign(state, { viewedIntro: true }),
    resetCurrenStep: state => Object.assign(state.progress, { currentStep: -1 }),
    resetActivityStore: (state) => {
        const initialState = Object.assign(Object.assign({}, getInitialActivityState()), { typing: getInitialTypingState() });
        Object.assign(state, Object.assign({}, initialState));
    },
    resetProgress: (state) => {
        Object.assign(state.progress, {
            roundIndex: -1,
            stepIndex: -1,
            completedSteps: []
        });
    },
    resetViewedIntro: state => Object.assign(state, { viewedIntro: false }),
    overwriteProgressStep: (state, step) => Object.assign(state.progress, { stepIndex: step }),
    setAssessmentHelpBtn: (state, showAssessmentHelpBtn) => Object.assign(state, { showAssessmentHelpBtn }),
    setTeacherAction: (state, teacherObject) => Object.assign(state, Object.assign({}, teacherObject)),
    setSpotCheckRetries: (state, spotCheckRetries) => Object.assign(state, { spotCheckRetries }),
    setActivityRestarting: (state, { isRestarting, showIntro = true }) => Object.assign(state, { isRestarting, showIntro })
};
